
import React, { PureComponent } from 'react';
import './BannerAndStaticHTML.scss';

class BannerAndStaticHTML extends PureComponent {

    componentDidMount() {
        const { bannerData, id } = this.props;
        if (bannerData[0].html && bannerData[0].script) {
            this.createScriptTag(id, bannerData[0].script);
        }
    }

    componentWillUnmount() {
        const { id } = this.props;
        const scriptEl = document.querySelector(id ? `#${id}` : '#bannerAndStaticHTML');
        if (scriptEl) {
            document.body.removeChild(scriptEl);
        }
    }

    createScriptTag = (id = 'bannerAndStaticHTML', scriptToAppend) => {
        const script = document.createElement('script');
        script.id = id;
        script.innerHTML = scriptToAppend;
        document.body.appendChild(script);
    }

    render() {
        const { bannerData, className, style, id, verticalPosition} = this.props;
        let htmlString;
        if (!bannerData) {
            return (
                <div style={{ height: '200px', background: 'url(https://static.lenskart.com/media/mobile/images/img-loader.gif) center no-repeat' }}></div>
            );
        }
        const cssId = id ? `idf_${id}` : '';
        const cssClass = className ? `${className} bannerStatic` : 'bannerStatic';
        return (
            <section className={cssClass} style={style} id={cssId}>
                {
                    bannerData && bannerData.map((data, index) => {
                        if (data.html) {
                            const css = data.css ? data.css : '';
                            htmlString = data.html + css;
                        } else if (data.url && data.src) {
                            htmlString = `<div class="bannerStatic_banner"><a href="${data.url}" onclick="dtm.LenskartRewamp.collection.click.bannerclickdtm('${data.pageName}', '${data.componentName}', ${index + 1}, null , '${verticalPosition}');"><img src="${data.src}" alt="${data.title}" title="${data.title}" /></a></div>`;
                        } else if (data.src) {
                            htmlString = `<div class="bannerStatic_banner"><img src="${data.src}" alt="${data.title}" title="${data.title}" /></div>`;
                        }
                        return (
                            htmlString && <div key={`banner-item-${index}`} dangerouslySetInnerHTML={{ __html: htmlString }}>
                            </div>
                        );
                    })
                }
            </section>
        );
    }
}

export default BannerAndStaticHTML;


